import clsx from "clsx";

import styles from "./heading.module.css";

interface HeadingProps {
  className?: string;
  text: string;
  level: "1" | "2" | "3";
}

function Heading({ text, level, className = "" }: HeadingProps) {
  switch (level) {
    case "1": {
      return (
        <h1 className={clsx(styles.heading, styles.heading1, className)}>
          {text}
        </h1>
      );
    }
    case "2": {
      return (
        <h2 className={clsx(styles.heading, styles.heading2, className)}>
          {text}
        </h2>
      );
    }

    case "3": {
      return (
        <h3 className={clsx(styles.heading, styles.heading3, className)}>
          {text}
        </h3>
      );
    }

    default: {
      throw new Error("Level is required");
    }
  }
}

export default Heading;
